import EmptyView      from 'scripts/defa/basic/view-empty-view';
import ForecastView   from 'scripts/defa/weather/view-forecast-view';
import CollectionView from 'scripts/poppet/collection-view';


/**
 * defa.views.ForecastView
 * The DEFA view for Forecasts.
 * @version 1.3.0
 */

const ForecastCollectionView = CollectionView.extend( {
	
	childView        : ForecastView,
	emptyView        : EmptyView,
	emptyViewOptions : {
		context: 'noweather',
	},
	className: 'weather-list', 
	tagName: 'ul',
	
} );

export default ForecastCollectionView;